import { createRouteRef, type RouteRef } from '@backstage/frontend-plugin-api';

export const rootRouteRef: RouteRef = createRouteRef();

export const SCORECARD_ENTITY_ROUTE = '/scorecard';
